import { useQuery } from "@tanstack/react-query"
import { getDashboardStats } from "@/services/api/dashboard"
import { isValid } from "date-fns"

export const useFetchDashboardStats = (startDate, endDate) => {
  return useQuery({
    queryKey: ["dashboard", startDate?.toISOString(), endDate?.toISOString()],
    queryFn: async () => {
      if (!startDate || !endDate || !isValid(startDate) || !isValid(endDate)) {
        throw new Error("Invalid date range")
      }
      const response = await getDashboardStats(startDate, endDate)
      return response.data
    },
    select: (response) => response.data,
    staleTime: 5 * 60 * 1000,
    enabled: Boolean(
      startDate && endDate && isValid(startDate) && isValid(endDate)
    ),
    retry: 1,
    onError: (error) => {
      console.error("Dashboard query error:", error)
    },
  })
}
